<style scoped>
.user-image {
    width: 50px;
    height: 50px;
}
</style>

<template>
    <div v-if="loading && !toplist" class="d-flex align-center justify-center">
        <v-progress-circular size="20" indeterminate color="primary" width="2"></v-progress-circular>
    </div>
    <div v-else-if="error">
        <v-alert type="error">
            <span v-if="error">{{ $translate('Error loading table') }}</span>
        </v-alert>
    </div>
    <div v-else-if="toplist">
        <v-data-table
            :headers="tableHeaders"
            :items="tableRows"
            class="teamsport-table elevation-1"
            :items-per-page="-1"
            :hide-default-footer="true"
            :hide-default-header="false"
            :mobile-breakpoint="0"
            :disable-sort="true"
        >
            <template v-slot:item="{ item }">
                <tr>
                    <td v-for="(header, index) in tableHeaders" :key="index">
                        <div v-if="header.value == 'name'" class="d-flex align-center">
                            <v-avatar v-if="type == 'player' && $store.state.isLoggedIn" :size="mobile ? 30 : 40" class="mr-2">
                                <img :src="'/api/memberapi/image/member/get?size=50x50&id=' + item.id" class="user-image" />
                            </v-avatar>
                            <v-avatar v-if="type == 'team'" :size="mobile ? 30 : 40" class="mr-2">
                                <img  :src="'/api/public/image/get?size=50x50&type=team&id=' + item.id" class="user-image" />
                            </v-avatar>
                            {{ item[header.value] }} <br/> {{ item.team }}
                        </div>
                        <template v-else>
                            {{ item[header.value] }}
                        </template>
                    </td>
                </tr>
            </template>
        </v-data-table>
    </div>
</template>

<script>
export default {
    name: 'zoezi-teamsport-toplist',

    zoezi: {
        title: 'Series leaderboard',
        icon: 'mdi-table-large',
        addon: 'TeamSports'
    },

    props: {
        divisionId: {
            title: 'Division ID',
            type: Number
        },
        toplistId: {
            title: 'Toplist ID',
            type: Number
        }
    },

    watch: {
        divisionId: {
            immediate: true,
            handler() {
                this.loadToplists();
            }
        }
    },

    data: () => ({
        loading: false,
        error: false,
        toplist: null,
        datatypes: null,
        unsubscribe: [],
        tableRows: []
    }),

    computed: {
        mobile() {
            return this.$vuetify.breakpoint.mobile
        },
        type() {
            return this.toplist.toplist.type;
        },
        tableHeaders() {
            const title = this.$translate(this.toplist.toplist.type == 'player' ? 'Player' : 'Team');
            let res = [
                {text: '#', value: 'position'},
                {text: title, value: 'name'},
            ];
            if (this.toplist.toplist.show_num_matches) {
                res.push({text: this.$translate('Matches'), value: 'num_matches'});
            }

            this.toplist.toplist.typelist.forEach(tp => {
                const et = this.datatypes.eventtype.find(x => x.id == tp.eventtype);
                res.push({text: et.name, value: 'et' + et.id } );
            });

            res.push({text: this.$translate('Points'), value: 'points'});

            return res;
        }
    },

    methods: {
        initializeTable() {
            this.tableRows = this.toplist.items.map(row => {
                let rowData = {};
                this.tableHeaders.forEach((header) => {
                    if (header.value == 'name') {
                        let item = this.datatypes[this.toplist.toplist.type].find(x => x.id == row.id);
                        rowData.name = item.name;
                        rowData.id = item.id;
                        rowData.team = item.team;
                    } else if (header.value.startsWith('et')) {
                        let type = header.value.substring(2);
                        rowData[header.value] = row.eventtypes[type];
                    } else {
                        rowData[header.value] = row[header.value];
                    }
                });
                return rowData;
            });
        },
        loadToplists() {
            this.loading = true;
            this.$api.get('/api/memberapi/teamsport/toplist/for_division', {division_id: this.divisionId, toplist_id: this.toplistId}).then(data => {
                this.toplist = data.toplists.find(x => x.toplist.id == this.toplistId);
                if (!this.toplist) {
                    this.loading = false;
                    this.error = true;
                    return;
                }
                this.datatypes = data.datatypes;
                this.initializeTable();
                this.loading = false;
            });
        },
        getTeamLogo(imagetype, id) {
            return `/api/public/image/get?type=${imagetype}&id=${id}&size=30x30`;
        }
    },
    destroyed() {
        this.unsubscribe.forEach(x => x());
    },
    mounted() {
        this.unsubscribe.push(this.$api.subscribe({type: 'teamsporttoplist',  callback: () => {
            this.loadToplists();
        }}));
        this.unsubscribe.push(this.$api.subscribe({type: 'teamsportdivision',  callback: (_, event) => {
            if (event.data.find(x => x.id == this.divisionId)) {
                this.loadToplists();
            }
        }}));
        this.unsubscribe.push(this.$api.subscribe({type: 'teamsportmatch',  callback: (_, event) => {
            if (event.data.find(x => x.division_id == this.divisionId)) {
                this.loadToplists();
            }
        }}));
    }
}
</script>
